
import { SistemaMixin } from "@/modules/Application";
import { mapGetters } from "vuex";
import TrashCan from "vue-material-design-icons/TrashCan.vue";

let _keyCounter = 0;

export default {
  name: "app-novidades-admin-form",
  mixins: [SistemaMixin],
  components: {
    TrashCan,
  },
  data() {
    return {
      carregando: false,
      salvando: false,
      form: {
        titulo: "",
        versao: "",
        descricao_curta: "",
        descricao: "",
        data_publicacao: "",
        publicado: false,
        destacar_dashboard: false,
        exibir_modal: false,
        itens: [],
      },
      tiposItem: [
        { value: "funcionalidade", label: "Nova funcionalidade" },
        { value: "melhoria", label: "Melhoria" },
        { value: "correcao", label: "Correção" },
        { value: "comunicado", label: "Comunicado" },
        { value: "treinamento", label: "Treinamento" },
        { value: "importante", label: "Importante" },
      ],
    };
  },
  computed: {
    isUpdate() {
      return !!this.$route.params.id;
    },
    ...mapGetters(["isNuts"]),
  },
  async mounted() {
    if (!this.isNuts) {
      this.$router.push({ name: "dashboard" });
      return;
    }
    this.$store.dispatch("setLoading", false);
    if (this.isUpdate) {
      await this.carregar();
    }
  },
  methods: {
    async carregar() {
      this.carregando = true;
      try {
        const { data } = await this.$http.post("/novidades/admin/find", {
          id: this.$route.params.id,
        });
        const pacote = data.data || data;
        this.form = {
          titulo: pacote.titulo || "",
          versao: pacote.versao || "",
          descricao_curta: pacote.descricao_curta || "",
          descricao: pacote.descricao || "",
          data_publicacao: pacote.data_publicacao
            ? pacote.data_publicacao.substring(0, 10)
            : "",
          publicado: !!pacote.publicado,
          destacar_dashboard: !!pacote.destacar_dashboard,
          exibir_modal: !!pacote.exibir_modal,
          itens: (pacote.itens || []).map((item) => ({
            ...item,
            _key: ++_keyCounter,
          })),
        };
      } catch (error) {
        this.$toast.error(
          error?.response?.data?.msg ||
          error?.response?.data?.message ||
          "Não foi possível carregar o pacote."
        );
        this.$router.push({ name: "novidadesAdmin" });
      } finally {
        this.carregando = false;
      }
    },

    adicionarItem() {
      this.form.itens.push({
        _key: ++_keyCounter,
        titulo: "",
        tipo: "funcionalidade",
        descricao_curta: "",
        descricao: "",
        icone: "",
        imagem: "",
        video_url: "",
        documentacao_url: "",
        ordem: this.form.itens.length + 1,
      });
    },

    removerItem(index) {
      this.form.itens.splice(index, 1);
    },

    async salvar() {
      if (!this.form.titulo || !this.form.titulo.trim()) {
        this.$toast.error("O título do pacote é obrigatório.");
        return;
      }

      this.salvando = true;
      try {
        const payload = {
          ...this.form,
          itens: this.form.itens.map(({ _key, ...item }) => item),
        };

        if (this.isUpdate) {
          await this.$http.post("/novidades/admin/update", {
            id: this.$route.params.id,
            ...payload,
          });
        } else {
          await this.$http.post("/novidades/admin/create", payload);
        }

        this.$toast.success("Pacote de novidades salvo com sucesso.");
        this.$router.push({ name: "novidadesAdmin" });
      } catch (error) {
        this.$toast.error(
          error?.response?.data?.msg ||
          error?.response?.data?.message ||
          "Não foi possível salvar o pacote."
        );
      } finally {
        this.salvando = false;
      }
    },
  },
};
